import { renderApplication } from '../renderApplication';

export function runApp() {
  renderApplication();
}
